// The IronCRM logo (the public brand, DSH-025), white on the dark page. The
// file name carries a content hash; replace the file and the name together.
export const BRAND_LOGO_WHITE = "/media/logo-white.78e98efbd3.svg";

// The browser-tab and home-screen icons: the logo's ring mark alone, no redraw
// (media/icon.*.svg is the logo's two circles; the PNG and ICO files are
// rasterized from the same geometry). /favicon.ico keeps its fixed name
// because browsers ask for it without a link.
export const SITE_ICONS = {
  icon: [
    { url: "/favicon.ico", sizes: "16x16 32x32 48x48" },
    { url: "/media/icon.f77daad098.svg", type: "image/svg+xml" },
  ],
  apple: [{ url: "/media/apple-touch-icon.22c4debd8e.png", sizes: "180x180", type: "image/png" }],
};
